import { fromArrayToObject } from '@interlayer/js/app/utils/common.util';

/* Additional types 'desktopCompanion', 'whatsApp' */
export enum CONTACT_TYPES {
    email = 'email',
    SMS = 'SMS',
    phone = 'phone',
    directMail = 'directMail',
    mobilePush = 'mobilePush',
    internalMessage = 'internalMessage',
    slotClubParticipation = 'slotClubParticipation'
}

export enum CONTACT_TYPES_FRONT {
    email = 'contactByEmail',
    SMS = 'contactBySMS',
    phone = 'contactByPhone',
    directMail = 'contactByDirectMail',
    mobilePush = 'contactByMobilePush',
    internalMessage = 'contactByInternalMessage',
    slotClubParticipation = 'slotClubParticipation'
}

export const SLOT_OPTIN_PRODUCT = 'casino';

export enum CHECKBOX_LIST_ICON {
    selectAll = 'check',
    email = 'mail',
    SMS = 'mobile-phone',
    phone = 'phone',
    directMail = 'mail-open',
    mobilePush = 'mobile-push',
    internalMessage = 'internal-message',
    slotClubParticipation = 'slots'
}

export const DEFAULT_MARKETING_PRODUCTS = ['bingo', 'casino'];

export const CONFIRM_MARKETING_CASINO_OPTIN_ID = 'confirmMarketingCasinoOptIn';

type TMarketingCheckbox = {
    icon: CHECKBOX_LIST_ICON;
    imsName: CONTACT_TYPES;
    name: CONTACT_TYPES_FRONT;
};

const MARKETING_CHECKBOXES_ARRAY: TMarketingCheckbox[] = Object.values(CONTACT_TYPES).map(contactType => ({
    icon: CHECKBOX_LIST_ICON[contactType],
    imsName: CONTACT_TYPES[contactType],
    name: CONTACT_TYPES_FRONT[contactType]
}));

export const MARKETING_CHECKBOXES_IMS: Record<CONTACT_TYPES, TMarketingCheckbox> = fromArrayToObject({ data: MARKETING_CHECKBOXES_ARRAY, key: 'imsName', filter: null });
export const MARKETING_CHECKBOXES_FRONT: Record<CONTACT_TYPES_FRONT, TMarketingCheckbox> = fromArrayToObject({ data: MARKETING_CHECKBOXES_ARRAY, key: 'name', filter: null });

export const MAIN_CONTACT_TYPES = [CONTACT_TYPES.email, CONTACT_TYPES.SMS, CONTACT_TYPES.phone, CONTACT_TYPES.directMail];
export const OPTIONAL_CONTACT_TYPES = [CONTACT_TYPES.mobilePush, CONTACT_TYPES.internalMessage];

export const MAIN_CONTACT_TYPES_FRONT = [
    CONTACT_TYPES_FRONT.email,
    CONTACT_TYPES_FRONT.SMS,
    CONTACT_TYPES_FRONT.phone,
    CONTACT_TYPES_FRONT.directMail
];

export const OPTIONAL_CONTACT_TYPES_FRONT = [
    CONTACT_TYPES_FRONT.mobilePush,
    CONTACT_TYPES_FRONT.internalMessage
];

export const ALL_CONTACT_TYPES = [
    ...MAIN_CONTACT_TYPES,
    ...OPTIONAL_CONTACT_TYPES
];

export const ALL_CONTACT_TYPES_FRONT = [
    ...MAIN_CONTACT_TYPES_FRONT,
    ...OPTIONAL_CONTACT_TYPES_FRONT
];

export const SELECT_ALL_FIELD = 'selectAll';
